import { render, staticRenderFns } from "./BackHome.vue?vue&type=template&id=ef1f56e6"
import script from "./BackHome.vue?vue&type=script&lang=js"
export * from "./BackHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports